<template>
  <div>
    <!-- 遮罩 -->
    <div class="bg" v-show="visiable" @click="maskClosable && close()"></div>
    <div class="box" v-show="visiable" :style="styleObj">
      <!-- <a-icon type="close" class="close" @click="close" /> -->
      <svg-icon icon-class="close" class="close" @click="close"></svg-icon>
      <div class="body">
        <canvas class="qr" id="QRCode_header"> </canvas>
        <div class="desc">{{ desc }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import { addShare } from "@/api/qrCode";
export default {
  name: "qrCode",
  props: {
    visiable: {
      type: Boolean,
      default: false,
    },
    maskClosable: {
      type: Boolean,
      default: false,
    },
    width: {
      type: String,
      default: "480px",
    },
    height: {
      type: String,
      default: "438px",
    },
    title: {
      type: String,
      default: "二维码",
    },
    desc: {
      type: String,
      default: "扫一扫上面的二维码，分享账号",
    },
    url: {
      type: String,
      default: "",
    },
    businessType: {
      type: String,
      default: "",
    },
    targetDesc: {
      type: String,
      default: "",
    },
    targetId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      styleObj: {
        width: this.width,
        height: this.height,
      },
    };
  },
  computed: {},
  watch: {
    url(val) {
      if (val) {
        this.getQrcode();
      }
    },
  },
  mounted() {
    this.getQrcode();
  },
  methods: {
    close() {
      this.$emit("update:visiable", false);
    },
    getQrcode() {
      let opts = {
        errorCorrectionLevel: "H", //容错级别
        type: "image/png", //生成的二维码类型
        quality: 0.3, //二维码质量
        margin: 0, //二维码留白边距
        width: 222, //宽
        height: 223, //高
        text: "", //二维码内容
        color: {
          dark: "#333333", //前景色
          light: "#fff", //背景色
        },
      };
      console.log(this.url);
      addShare({
        businessType: this.businessType,
        targetDesc: this.targetDesc,
        targetId: this.targetId,
      });
      // this.QRCodeMsg = "http://www.baidu.com"; //生成的二维码为URL地址js
      let msg = document.getElementById("QRCode_header");
      //拼接外部参数
      const paramsKey = [
        "tenant",
        "page",
        "uid",
        "tel",
        "cid",
        "corp",
        "parkId",
      ];
      let search = "";
      if (this.url.indexOf("?") > -1) {
        search += "&";
      } else {
        search += "?";
      }
      paramsKey.forEach((i) => {
        let value = sessionStorage.getItem(i);
        search = search + i + "=" + value + "&";
      });
      search = search.substr(0, search.length - 1);
      // 将获取到的数据（val）画到msg（canvas）上
      console.log("qrcode", this.url + search);
      QRCode.toCanvas(msg, this.url + search, opts, function (error) {
        console.log(error);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.bg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #000;
  opacity: 0.3;
  z-index: 99;
}

.box {
  width: 480px;
  height: 438px;
  background: url("../../assets/images/bg5.png") no-repeat;
  background-size: cover;
  background-position: center;
  position: absolute;
  background-color: #fff;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 100;
  padding: 20px;
}

.close {
  position: absolute;
  top: 24px;
  right: 24px;
  font-size: 10px;
  text-align: center;
  cursor: pointer;
  z-index: 100;
}

.head {
  height: 54px;
  line-height: 54px;
  padding-left: 24px;
  font-size: 16px;
  font-weight: 500;
  color: rgba(0, 0, 0, 0.85);
  border-bottom: 1px solid #666;
}

.body {
  margin: 0 auto;
  margin-top: 59px;
  width: 255px;
  height: 281px;
  box-shadow: 0px 2px 4px 0px rgba(0, 114, 247, 0.2);
  border-radius: 8px;
  padding-top: 15px;
  padding-bottom: 12px;

  .qr {
    display: block;
    width: 222px;
    height: 223px;
    margin: 0 auto;
  }

  .desc {
    margin-top: 10px;
    font-size: 16px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #333333;
    text-align: center;
  }
}
</style>